import { useEffect } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Portfolio } from './components/Portfolio';
import { Manifesto } from './components/Manifesto';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { useReveal } from './hooks/useReveal';
import { useTheme } from './hooks/useTheme';
import { useTranslations, type Locale } from './i18n/ui';
import './styles/landing.css';

interface Props {
  locale: Locale;
}

const HTML_LANG: Record<Locale, string> = {
  'pt-br': 'pt-BR',
  en: 'en',
  es: 'es',
  fr: 'fr',
  zh: 'zh',
  hi: 'hi',
  ar: 'ar',
  bn: 'bn',
  ru: 'ru',
  ja: 'ja',
};

export function LandingPage({ locale }: Props) {
  const t = useTranslations(locale);
  useTheme();
  useReveal();

  useEffect(() => {
    const html = document.documentElement;
    const prevLang = html.lang;
    const prevDir = html.dir;
    html.lang = HTML_LANG[locale] ?? 'pt-BR';
    html.dir = locale === 'ar' ? 'rtl' : 'ltr';
    document.title = t('meta.title');
    return () => {
      html.lang = prevLang;
      html.dir = prevDir;
    };
  }, [locale, t]);

  return (
    <>
      <Nav t={t} locale={locale} />
      <main>
        <Hero t={t} />
        <Portfolio t={t} />
        <Manifesto t={t} />
        <FinalCTA t={t} />
      </main>
      <Footer t={t} />
    </>
  );
}
